import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SurveyForm } from './SurveyForm';
import { useAnswerSurveyFormDialog } from './useAnswerSurveyFormDialog';
import { useSxStyles } from './useStyles';

type Props = {
  surveyId: string;
  handleAnswerClose: () => void;
};

export const AnswerSurveyFormDialog: React.FC<Props> = ({
  surveyId,
  handleAnswerClose,
}) => {
  const { t } = useTranslation();
  const {
    open,
    onDialogClose,
    surveyAnswer,
    title,
    subTitle,
    handleFormSubmit,
    control,
    errors,
  } = useAnswerSurveyFormDialog(surveyId, handleAnswerClose);
  const sxStyles = useSxStyles();

  return (
    <Dialog
      open={open}
      aria-labelledby="answer-form-dialog"
      onClose={onDialogClose}
      color="primary"
      maxWidth="md"
      PaperProps={{ sx: sxStyles.paperWidthMd }}
    >
      <DialogTitle>
        <>
          {title}
          <Typography component="p" variant="subtitle2" gutterBottom>
            {subTitle}
          </Typography>
        </>
      </DialogTitle>
      <DialogContent>
        {surveyAnswer.questions ? (
          <SurveyForm
            control={control}
            errors={errors}
            questions={surveyAnswer.questions}
          />
        ) : (
          <CircularProgress size="small" />
        )}
      </DialogContent>
      <DialogActions sx={sxStyles.dialogActions}>
        <Button
          variant="text"
          component="a"
          color="primary"
          onClick={onDialogClose}
        >
          {t('laCancel')}
        </Button>
        <Button
          variant="contained"
          color="secondary"
          type="submit"
          onClick={(e) => {
            e.preventDefault();
            handleFormSubmit();
          }}
        >
          {t('laSend')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
